import styled from 'styled-components';

export const Content = styled.div`
  background-color: white;
  margin-left: 250px;
  padding: 25px;
`;
